module.exports = __webpack_public_path__ + "static/media/bundle_right_arrow.c1d880ec.svg";